import React from "react";
import { Route } from "react-router";
import Applications from "pages/applications/main";
import AddApplication from "pages/applications/add";
import EditApplication from "pages/applications/edit";
import Reviews from "pages/application-reviews/main";
import EditReview from "pages/application-reviews/edit";
import CustomPlans from "pages/application-custom-plans/main";
import AddCustomPlan from "pages/application-custom-plans/add";
import EditCustomPlan from "pages/application-custom-plans/edit";
import AuthRoute from "helpers/authentication/authRoute";

const ApplicationRoutes = () => (
    <>
        <Route
            path="/applications"
            element={
                <AuthRoute>
                    <Applications />
                </AuthRoute>
            }
        />
        <Route
            path="/applications/add"
            element={
                <AuthRoute>
                    <AddApplication />
                </AuthRoute>
            }
        />
        <Route
            path="/applications/:applicationId"
            element={
                <AuthRoute>
                    <EditApplication />
                </AuthRoute>
            }
        />
        <Route
            path="/applications/:applicationId/revisions"
            element={
                <AuthRoute>
                    <Reviews />
                </AuthRoute>
            }
        />
        <Route
            path="/applications/:applicationId/revisions/:id"
            element={
                <AuthRoute>
                    <EditReview />
                </AuthRoute>
            }
        />
        <Route
            path="/applications/:applicationId/custom-plans"
            element={
                <AuthRoute>
                    <CustomPlans />
                </AuthRoute>
            }
        />
        <Route
            path="/applications/:applicationId/custom-plans/add"
            element={
                <AuthRoute>
                    <AddCustomPlan />
                </AuthRoute>
            }
        />
        <Route
            path="/applications/:applicationId/custom-plans/:id"
            element={
                <AuthRoute>
                    <EditCustomPlan />
                </AuthRoute>
            }
        />
    </>
);

export default ApplicationRoutes;
